import { Button, type ButtonProps, cn } from '@repo/ui';
import type { ReactElement } from 'react';

/**
 * 폼을 마무리하는 전폭 버튼 — 높이 56px, 각진 모서리.
 * 기본은 흑연(primary) 바탕에 흰 글자 — 어두운 테마에서는 primary 가 라임이라 글자를 primary-foreground 로 돌린다.
 * variant="outline" 은 같은 크기의 보조 버튼이다.
 */
export const BlockButton = ({
  className,
  variant,
  ...props
}: Omit<ButtonProps, 'size'>): ReactElement => {
  const isPrimary = !variant || variant === 'default';

  return (
    <Button
      variant={variant}
      className={cn(
        'h-14 w-full rounded-none px-6 text-[15px] font-semibold',
        isPrimary && 'bg-primary text-white hover:bg-primary/90 dark:text-primary-foreground',
        variant === 'outline' && 'border-foreground/15 hover:border-foreground hover:bg-background',
        className,
      )}
      {...props}
    />
  );
};
